import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        this.initMenu();
        this.initHorizontalScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", () => {
            this.scrollToHash();
        });
        window.addEventListener("hashchange", () => {
            this.scrollToHash();
        });
    }

    scrollToHash() {
        // Native anchor jump aligns the section's right edge (inline: nearest), which cuts off the
        // start of sections wider than the viewport; on load it also runs before images get their widths
        const target = window.location.hash && document.getElementById(window.location.hash.slice(1));
        if (target) {
            target.scrollIntoView({ block: 'start', inline: 'start' });
        }
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", () => {
        });
    }

    initHorizontalScroll() {
        document.addEventListener("DOMContentLoaded", () => {
            const container = document.querySelector('.b-container');
            if (!container) return;

            function isDesktop() {
                return window.innerWidth > 768;
            }

            window.addEventListener('wheel', (e) => {
                if (!isDesktop()) return;

                e.preventDefault();

                if (Math.abs(e.deltaX) > 0) {
                    container.scrollLeft += e.deltaX * 30;
                } else {
                    container.scrollLeft += e.deltaY;
                }
            }, { passive: false });
        });
    }

    initMenu() {
        document.addEventListener("DOMContentLoaded", () => {
            const menuToggle = document.querySelector('.bb-menu-toggle');
            const menu = document.querySelector('.bb-menu');
            const menuClose = document.querySelector('.bb-menu__close');

            if (!menuToggle || !menu) return;

            menuToggle.addEventListener('click', () => {
                menu.classList.add('is-open');
                menuToggle.classList.add('is-open');
                document.body.classList.add('menu-open');
            });

            const closeMenu = () => {
                menu.classList.remove('is-open');
                menuToggle.classList.remove('is-open');
                document.body.classList.remove('menu-open');

                // Close all sub-menus when closing main menu
                const openSubmenus = document.querySelectorAll('.menu-item-has-children.is-open');
                openSubmenus.forEach(item => {
                    item.classList.remove('is-open');
                    const submenu = item.querySelector('.sub-menu');
                    if (submenu) submenu.classList.remove('is-open');
                });
            };

            if (menuClose) {
                menuClose.addEventListener('click', closeMenu);
            }

            // Handle submenu toggles - add arrows dynamically
            const initSubmenus = () => {
                const parentMenuItems = document.querySelectorAll('.menu-item-has-children');
                console.log('Found parent menu items:', parentMenuItems.length);

                parentMenuItems.forEach(item => {
                    const links = item.querySelectorAll('a');
                    let firstLinkMain = links[0];
                    console.log(firstLinkMain);
                    const link = links[0]; // First link is the parent link
                    if (!link) return;

                    let arrow = item.querySelector('.submenu-arrow');
                    if (!arrow) {
                        arrow = document.createElement('span');
                        arrow.className = 'submenu-arrow';

                        const submenu = item.querySelector('.sub-menu');
                        if (submenu) {
                            // Add arrow inside the link element
                            firstLinkMain.append(arrow);
                        } else {
                            item.appendChild(arrow);
                        }

                        console.log('Arrow added to:', link.textContent.trim());

                        // Arrow click handler - tylko raz
                        arrow.addEventListener('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Arrow clicked for:', link.textContent.trim());

                            const submenu = item.querySelector('.sub-menu');
                            if (submenu) {
                                // Close other submenus
                                const otherOpenItems = document.querySelectorAll('.menu-item-has-children.is-open');
                                otherOpenItems.forEach(otherItem => {
                                    if (otherItem !== item) {
                                        otherItem.classList.remove('is-open');
                                        const otherSubmenu = otherItem.querySelector('.sub-menu');
                                        if (otherSubmenu) otherSubmenu.classList.remove('is-open');
                                    }
                                });

                                // Toggle current submenu
                                const isOpen = item.classList.toggle('is-open');
                                submenu.classList.toggle('is-open');
                                console.log('Submenu is now:', isOpen ? 'OPEN' : 'CLOSED');
                            } else {
                                console.log('No submenu found!');
                            }
                        });
                    }
                });
            };

            // Initialize submenus when menu opens
            setTimeout(initSubmenus, 500);

            // Close on child link click (submenu items)
            const submenuLinks = document.querySelectorAll('.sub-menu a');
            submenuLinks.forEach(link => {
                link.addEventListener('click', () => {
                    closeMenu();
                });
            });

            // Close on ESC key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && menu.classList.contains('is-open')) {
                    closeMenu();
                }
            });

            // Close on outside click
            document.addEventListener('click', (e) => {
                if (menu.classList.contains('is-open') &&
                    !menu.contains(e.target) &&
                    !menuToggle.contains(e.target)) {
                    closeMenu();
                }
            });
        });
    }

    onResize() {
        window.addEventListener('resize', () => {

        });
    }

    onScroll() {
        window.addEventListener('scroll', () => {

        });
    }
}

new Main();
